import React from 'react';
import PropTypes from 'prop-types';
import Select from '.';
import { TIME_INPUT_LABEL } from '../../../assets/copy';
import Typography from '../../overrides/Typography';

export const TimeSelector = ({
  dropdownLabel = TIME_INPUT_LABEL,
  OptionComponent = 'option',
  ...rest
}) => {
  const options = [];
  const startTime = new Date();
  startTime.setHours(0, 0, 0, 0);
  const endTime = new Date();
  endTime.setHours(23, 59, 59, 999);
  let currentTime = new Date(startTime);
  for (let i = 0; currentTime <= endTime; i++) {
    const formattedTime = currentTime.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
    currentTime.setMinutes(currentTime.getMinutes() + 30);
    options.push(
      <OptionComponent key={i} value={formattedTime}>
        <Typography variant="medium1Normal">
          {formattedTime}
        </Typography>
      </OptionComponent>
    );
  }

  return (
    <Select label={dropdownLabel} ariaLabel="Time" {...rest}>
      {options}
    </Select>
  );
};

export default TimeSelector;

TimeSelector.propTypes = {
  dropdownLabel: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
};
